export default __webpack_public_path__ + "static/media/lime-397 1.c4441e6f.png";